import { render, staticRenderFns } from "./_formCategory.vue?vue&type=template&id=3d60220f&scoped=true&"
import script from "./_formCategory.vue?vue&type=script&lang=js&"
export * from "./_formCategory.vue?vue&type=script&lang=js&"
import style0 from "./_formCategory.vue?vue&type=style&index=0&id=3d60220f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d60220f",
  null
  
)

export default component.exports